module.exports = __webpack_public_path__ + "static/media/bm-vhm.a2dd824f.png";